export default __webpack_public_path__ + "static/hiintcase2-497cdfc66dc4fb236f5e139a8516e32d.png";